<section>
    <div class="container">
    <p>Connecting Professionals from Canada, USA, Australia and UK with Singles in Hong Kong, Singapore, and Other
        Progressive Asian Cities</p>

    </div>
    



</section>

<section class="banner">
    <div class="buttons">
        <a class="navbar-brand" [routerLink]="['members']">Members</a>
    </div> 
    <div class="home_imgs">
            <img src="{{this.api.frontendAssetsUrl}}home1.jpg" alt="Meet Hong Kong Singles" />
            <img src="{{this.api.frontendAssetsUrl}}home2.jpg" alt="Meet Hong Kong Singles" />
            <img src="{{this.api.frontendAssetsUrl}}home3.jpg" alt="Meet Hong Kong Singles" />
            <img src="{{this.api.frontendAssetsUrl}}home4.jpg" alt="Meet Hong Kong Singles" />
    </div>
</section>


